import { InAppNotification } from '../../api/Types';

interface RawRealtimeNotificationPayload {
  id?: number;
  event_type?: InAppNotification['event_type'];
  recipe_id?: string | null;
  comment_id?: number | null;
  realization_id?: number | null;
  title?: string | null;
  body?: string | null;
  route_path?: string | null;
  is_read?: boolean | null;
  read_at?: string | null;
  created_at?: string | null;
}

const normalizeNumericId = (value: unknown): number | null =>
  typeof value === 'number' ? value : null;

export const createRealtimeNotification = (
  payload: RawRealtimeNotificationPayload
): InAppNotification => ({
  id: payload.id ?? 0,
  event_type: payload.event_type ?? 'recipe_created',
  recipe_id: payload.recipe_id || null,
  comment_id: normalizeNumericId(payload.comment_id),
  realization_id: normalizeNumericId(payload.realization_id),
  title: payload.title || 'Notification',
  body: payload.body || null,
  route_path: payload.route_path || '/',
  is_read: !!payload.is_read,
  read_at: payload.read_at || null,
  created_at: payload.created_at || new Date().toISOString(),
  actor: null,
});

export const mergeUnreadNotification = (
  notifications: InAppNotification[],
  incoming: InAppNotification,
  limit: number = 20
): InAppNotification[] => {
  return [incoming, ...notifications.filter((item) => item.id !== incoming.id)].slice(0, limit);
};

export const shouldBackfillUnreadList = (
  unreadNotificationsCount: number,
  notificationsLength: number
): boolean => unreadNotificationsCount > notificationsLength;
